import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DashboardInternal from "./pages/Dashboard/Internal";
import DashboardExternal from "./pages/Dashboard/external";
import DashboardJne from "./pages/Dashboard/jne";
import DashboardAll from "./pages/Dashboard/all";
import ListSurvey from "./pages/Dashboard/listSurvey";
import ParticipantDashboard from "./pages/Dashboard/participantDashboard";
import DashboardBpjs from "./pages/Dashboard/bpjs";
import LayoutAdminExternal from "./components/LayoutAdmin/external";
import LayoutAdminInternal from "./components/LayoutAdmin/internal";
import DashboardDynamic from "./pages/Dashboard/dynamic";
import DashboardBankKalteng from "./pages/Dashboard/bankkalteng";

import Home from "./pages/spex2/Home";

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<LayoutAdminInternal />}>
        <Route path="/:sid/:title" element={<ParticipantDashboard />} />
      </Route>
      <Route element={<LayoutAdminInternal />}>
        <Route path="/JNE/:id/:title" element={<DashboardJne />} />
      </Route>
      <Route element={<LayoutAdminInternal />}>
        <Route path="/bpjs" element={<DashboardBpjs />} />
      </Route>
      <Route element={<LayoutAdminInternal />}>
        <Route path="/bank-kalteng/:id/:title" element={<DashboardBankKalteng />} />
      </Route>
      <Route element={<LayoutAdminInternal />}>
        <Route path="/list-survey" element={<ListSurvey />} />
      </Route>
      <Route element={<LayoutAdminInternal />}>
        <Route path="/all" element={<DashboardAll />} />
      </Route>
      <Route path="/spex2" element={<Home />} />

      <Route element={<LayoutAdminExternal />}>
        <Route path="/external/:id" element={<DashboardExternal />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default App;
